/* DD Pawn Loans — "Heaviest to lightest" collection sort (2026-10-08).
   Shopify has no native weight sort, so this runs in the browser: when ?sort_by=weight-descending is
   in the URL it loads every page of the collection (Section Rendering API, same filters), reads each
   product's weight from the title ("13.5 Grams", "128g"), the variant grams, or the description,
   re-orders the product grid heaviest first (unknown weights last, original order kept), and turns the
   theme's infinite scroll off because everything is already on the page.
   The option itself is added in snippets/sorting.liquid. Loaded by layout/theme.liquid on collections only. */
(function () {
  'use strict';
  var KEY = 'weight-descending', LABEL = 'Heaviest to lightest';
  var WRE = /(\d+(?:[.,]\d+)?)\s*(?:grams?|gr|grm|g)\b/i;
  var busy = false, weightsCache = null;

  function active() { return new URL(location.href).searchParams.get('sort_by') === KEY; }
  function handle() { var m = location.pathname.match(/\/collections\/([^\/?#]+)/); return m ? m[1] : null; }
  function num(s) { var n = parseFloat(String(s).replace(',', '.')); return isFinite(n) && n > 0 ? n : null; }
  function text(html) { var d = document.createElement('div'); d.innerHTML = html || ''; return d.textContent || ''; }
  function weightOf(p) {
    var m = (p.title || '').match(WRE); if (m) return num(m[1]);
    var g = 0; (p.variants || []).forEach(function (v) { if (v.grams > g) g = v.grams; }); if (g > 0) return g;
    m = text(p.body_html).match(WRE); return m ? num(m[1]) : null;
  }
  async function weights() {
    if (weightsCache) return weightsCache;
    var h = handle(), map = {}; if (!h) return map;
    for (var page = 1; page <= 6; page++) {
      var r = await fetch('/collections/' + h + '/products.json?limit=250&page=' + page, { credentials: 'same-origin' });
      if (!r.ok) break;
      var j = await r.json(), ps = j.products || [];
      ps.forEach(function (p) { map[String(p.id)] = weightOf(p); });
      if (ps.length < 250) break;
    }
    weightsCache = map; return map;
  }
  function cardsIn(doc) { var g = doc.querySelector('[ref="grid"]'); return g ? Array.prototype.slice.call(g.querySelectorAll(':scope > [ref="cards[]"]')) : []; }
  async function allCards(rl, grid) {
    var last = Number(grid.dataset.lastPage || 1) || 1, sid = rl.getAttribute('section-id');
    var have = {}, cards = [];
    Array.prototype.forEach.call(grid.querySelectorAll(':scope > [ref="cards[]"]'), function (li) { have[li.dataset.page || '1'] = true; cards.push(li); });
    var jobs = [];
    for (var p = 1; p <= Math.min(last, 40); p++) (function (p) {
      if (have[String(p)]) return;
      var u = new URL(location.href); u.hash = ''; u.searchParams.set('page', String(p)); u.searchParams.set('section_id', sid);
      jobs.push(fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { return { p: p, cards: cardsIn(new DOMParser().parseFromString(html, 'text/html')) }; })
        .catch(function () { return { p: p, cards: [] }; }));
    })(p);
    var extra = await Promise.all(jobs);
    extra.forEach(function (e) { cards = cards.concat(e.cards); });
    return cards;
  }
  async function run() {
    if (busy || !active()) return;
    var rl = document.querySelector('results-list[section-id]'); var grid = rl && rl.querySelector('[ref="grid"]');
    if (!rl || !grid || grid.hasAttribute('data-dd-sorted')) return;
    busy = true; grid.setAttribute('aria-busy', 'true');
    try {
      var res = await Promise.all([weights(), allCards(rl, grid)]), map = res[0], cards = res[1];
      var seen = {}, rows = [];
      cards.forEach(function (li, i) { var id = String(li.dataset.productId || ''); if (!id || seen[id]) return; seen[id] = 1; rows.push({ li: li, w: map[id] == null ? null : map[id], i: i }); });
      rows.sort(function (a, b) { if (a.w == null && b.w == null) return a.i - b.i; if (a.w == null) return 1; if (b.w == null) return -1; return b.w - a.w || a.i - b.i; });
      rows.forEach(function (r) { r.li.dataset.page = '1'; });
      grid.replaceChildren.apply(grid, rows.map(function (r) { return r.li; }));
      grid.dataset.lastPage = '1'; grid.setAttribute('data-dd-sorted', '1');
      rl.querySelectorAll('[ref="viewMoreNext"],[ref="viewMorePrevious"]').forEach(function (e) { e.remove(); });
      if (!document.getElementById('dd-weight-sort-note')) {
        var n = document.createElement('p'); n.id = 'dd-weight-sort-note';
        n.style.cssText = 'margin:0 0 10px;font:500 12px/1.4 "IBM Plex Mono",ui-monospace,monospace;letter-spacing:.06em;text-transform:uppercase;color:#F5C542';
        grid.parentNode.insertBefore(n, grid);
      }
      var withW = rows.filter(function (r) { return r.w != null; }).length;
      document.getElementById('dd-weight-sort-note').textContent = LABEL + ' · ' + rows.length + ' items' + (withW < rows.length ? ' · ' + (rows.length - withW) + ' without a listed weight shown last' : '');
    } catch (e) { if (window.console) console.warn('dd-weight-sort', e); }
    grid.removeAttribute('aria-busy'); busy = false;
  }
  function markUI() {
    if (!active()) return;
    document.querySelectorAll('sorting-filter-component').forEach(function (c) {
      c.querySelectorAll('input[name="sort_by"]').forEach(function (i) { var on = i.value === KEY; i.checked = on; var o = i.closest('.sorting-filter__option'); if (o) { o.setAttribute('aria-selected', on ? 'true' : 'false'); o.tabIndex = on ? 0 : -1; } });
      var sel = c.querySelector('select[name="sort_by"]'); if (sel) sel.value = KEY;
      var st = c.querySelector('.facets__status'); if (st) st.textContent = LABEL;
    });
  }
  // Our option: go to the URL with sort_by=weight-descending (a full load keeps the theme's own sort code out of it).
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || t.name !== 'sort_by' || t.value !== KEY) return;
    e.stopImmediatePropagation(); e.preventDefault();
    var u = new URL(location.href); u.hash = ''; u.searchParams.set('sort_by', KEY); u.searchParams.delete('page');
    location.assign(u.toString());
  }, true);
  function boot() {
    markUI(); run();
    // Filters re-render the grid through the theme's section renderer in default order -> sort again.
    var rl = document.querySelector('results-list[section-id]'); if (!rl) return;
    var t; new MutationObserver(function () { if (!active() || busy) return; clearTimeout(t); t = setTimeout(function () { markUI(); run(); }, 120); })
      .observe(rl, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-last-page', 'data-dd-sorted'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('popstate', function () { setTimeout(function () { markUI(); run(); }, 50); });
})();
